import React from "react"

import {
    Box,
    Grid,
} from "@mui/material"

import {
    GoogleMap,
    LoadScript,
} from "@react-google-maps/api"
import debounce from "lodash/debounce"

import {
    AssetWithImage,
    GeoAssetFilter,
} from "models"
import { DashboardMapAssetMarker } from "components/dashboard"

interface MapAssetResultProps
{
    assetData: AssetWithImage
    location: {
        latitude: number
        longitude: number
    }
}
interface MapAssetResultState
{
    center: google.maps.LatLngLiteral
    assetFilter: GeoAssetFilter
}
export class MapAssetResult extends React.Component<MapAssetResultProps, MapAssetResultState>
{
    private mapRef: any = React.createRef();

    private readonly START_BOUND_NE_LAT = 46.709435930331
    private readonly START_BOUND_NE_LNG = 20.338623046875
    private readonly START_BOUND_SW_LAT = 36.914414468764
    private readonly START_BOUND_SW_LNG = 3.661376953125

    constructor(props: MapAssetResultProps)
    {
        super(props)
        this.state = {
            center: { lat: this.props.location.latitude, lng: this.props.location.longitude },
            assetFilter: {
                pageSize: 1,
                pageId: 0,
                orderType: null,
                orderBy: null,
                southWestLatitude: this.START_BOUND_SW_LAT,
                southWestLongitude: this.START_BOUND_SW_LNG,
                northEastLatitude: this.START_BOUND_NE_LAT,
                northEastLongitude: this.START_BOUND_NE_LNG,
                priorityId: null,
            }
        }
    }

    componentDidUpdate()
    {
        if(this.props.location.latitude === this.state.center.lat && this.props.location.longitude === this.state.center.lng) {
            return
        }

        this.setState(() => ({
            center: { lat: this.props.location.latitude, lng: this.props.location.longitude }
        }))
    }

    private setBoundsInState = (bounds: any): void => {
        this.setState(() => ({
            assetFilter: {
                ...this.state.assetFilter,
                northEastLatitude: bounds.northEastLat,
                southWestLongitude: bounds.southWestLon,
                southWestLatitude: bounds.southWestLat,
                northEastLongitude: bounds.northEastLon
            }
        }))
    }

    private handleBoundsChanged = debounce((): void => {
        const bounds = this.mapRef.getBounds();

        const northEast = bounds.getNorthEast();
        const southWest = bounds.getSouthWest();

        const newBounds = {
            northEastLat: northEast.lat().toFixed(4),
            northEastLon: northEast.lng().toFixed(4),
            southWestLat: southWest.lat().toFixed(4),
            southWestLon: southWest.lng().toFixed(4),
        }

        this.setBoundsInState(newBounds);
    }, 500)

    render()
    {
        return (
            <Grid container>
                <Grid item xs={12} sx={{mx: 2}}>
                    <Box style={{height: "55vh", width: "100%",}}>
                        <LoadScript googleMapsApiKey="AIzaSyCJiclrDzpvGD3bqTSp3NHlB4wQ7j-b1XQ">
                            <GoogleMap
                                id="map-home"
                                mapContainerStyle={{ height: "100%", width: "100%" }}
                                onBoundsChanged={this.handleBoundsChanged}
                                center={this.state.center}
                                zoom={17}
                                ref={this.mapRef}
                                onLoad={(map) => {
                                    this.mapRef = map
                                }}
                            >
                                <DashboardMapAssetMarker
                                    key={this.props.assetData.asset.id}
                                    item={this.props.assetData.asset}
                                    matches={this.props.assetData.asset.matches}
                                />
                            </GoogleMap>
                        </LoadScript>
                    </Box>
                </Grid>
            </Grid>
        )
    }
}
